interface ReferenceSourceProps {
  formData: any;
  updateFormData: (field: string, value: string) => void;
}

export default function ReferenceSource({ formData, updateFormData }: ReferenceSourceProps) {
  const sources = [
    'Sosyal Medya Reklamları',
    'Açık Hava Reklamları',
    'Web Sitesi',
    'Youtube',
    'TV',
    'E-posta',
    'SMS',
    'Radyo',
    'Dergi',
    'Gazete',
    'Tavsiye',
    'Diğer'
  ];

  return (
    <section className="bg-white rounded-xl shadow-sm p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-rose-100 rounded-lg flex items-center justify-center">
          <i className="ri-information-line text-rose-600 text-xl"></i>
        </div>
        <h2 className="text-xl font-semibold text-slate-800">Referans Kaynağı</h2>
      </div>

      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-3">
            Projemizden Nasıl Haberdar Oldunuz?
          </label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {sources.map((source) => (
              <label
                key={source}
                className="flex items-center gap-3 p-4 border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors cursor-pointer"
              >
                <input
                  type="radio"
                  name="referenceSource"
                  value={source}
                  checked={formData.referenceSource === source}
                  onChange={(e) => {
                    updateFormData('referenceSource', e.target.value);
                    if (e.target.value !== 'Tavsiye') {
                      updateFormData('referralName', '');
                    }
                  }}
                  className="w-4 h-4 text-emerald-600 cursor-pointer"
                />
                <span className="text-sm text-slate-700">{source}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Tavsiye Eden Kişi */}
        {formData.referenceSource === 'Tavsiye' && (
          <div className="animate-fadeIn">
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Tavsiye Eden Kişinin İsmi
            </label>
            <input
              type="text"
              name="referralName"
              value={formData.referralName}
              onChange={(e) => updateFormData('referralName', e.target.value)}
              className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all text-sm"
              placeholder="Tavsiye eden kişinin ismini girin"
            />
          </div>
        )}
      </div>
    </section>
  );
}
